export function normalizeCmsPath(path) {
  return '/' + String(path || '').split('?')[0].split('/').filter(Boolean).join('/') + (String(path || '/').replaceAll('/', '') ? '/' : '');
}

export function canResolveCmsRoute(route, path) {
  if (path === '/' || /^\/(si|hr|ba)\/$/.test(path) || /^\/(api|admin3?|shared|_nuxt)(\/|$)/.test(path) || /\.[a-z0-9]+\/$/i.test(path)) return false;
  if (!route) return true;
  if (['staticcontent', 'cmsstaticcontent'].includes(route.controller)) return true;
  return route.controller === 'cms' && (!route.content_type || route.content_type === 'page') && (!route.content || route.content === 'page') && (!route.template || ['cms/default', 'default'].includes(route.template));
}

export function replaceCmsRoute(data, path, route) {
  const index = data.routes.findIndex(item => item.path === path);
  const previous = index < 0 ? null : data.routes[index];
  const map = data.routesMap instanceof Map ? data.routesMap : null;
  const mapped = map?.get(path);
  if (index >= 0) data.routes.splice(index, 1);
  map?.delete(path);
  if (route) {
    data.routes.splice(index < 0 ? data.routes.length : index, 0, route);
    map?.set(path, route);
  }
  return () => {
    const current = route ? data.routes.indexOf(route) : -1;
    if (current >= 0) data.routes.splice(current, 1);
    if (map?.get(path) === route) map.delete(path);
    if (previous && !data.routes.some(item => item.path === path)) data.routes.splice(Math.min(index, data.routes.length), 0, previous);
    if (mapped && !map?.has(path)) map?.set(path, mapped);
  };
}
